<template>
   <div></div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
   name: 'OidcCallback',
   mounted() {
      this.oidcSignInCallback()
         .then((redirectPath) => {
            this.$router.push(redirectPath)
         })
         .catch((err) => {
            console.error(err)
            // Guardar el detalle del error para mostrarlo en la pantalla de error
            const detalle =
               (err && (err.message || err.error_description || err.error)) ||
               (typeof err === 'string' ? err : '') ||
               'Error desconocido al procesar la autenticación.'
            try {
               sessionStorage.setItem('oidcCallbackError', detalle)
            } catch (e) {
               // sessionStorage bloqueado; el detalle igual va en consola
            }
            this.$router.push('/oidc-callback-error') // Handle errors any way you want
         })
   },
   methods: {
      ...mapActions(['oidcSignInCallback', 'guardarPermisos'])
   }
}
</script>
